import { UserAvatar } from './UserAvatar';

interface Participant {
  user_id: string;
  display_name: string;
  avatar_url?: string;
}

interface Props {
  participants: Participant[];
  size?: number;
  max?: number;
}

export default function ParticipantAvatars({ participants, size = 18, max = 5 }: Props) {
  const shown = participants.slice(0, max);
  const overflow = participants.length - max;

  return (
    <span className="participant-avatars">
      {shown.map(p => (
        <span key={p.user_id} title={p.display_name}>
          <UserAvatar userId={p.user_id} displayName={p.display_name} avatarUrl={p.avatar_url} size={size} showPresence={false} />
        </span>
      ))}
      {overflow > 0 && <span className="participant-avatars-overflow">+{overflow}</span>}
    </span>
  );
}
